// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  BodyUploadMcqOptionImage,
  BodyUploadMcqQuestionImage,
  HTTPValidationError,
  MCQConfigInput,
  MCQConfigOutput,
  MCQGenerationRequest,
  MCQQuestion,
  MCQQuestionCreate,
  MCQQuestionUpdate,
} from '../../models';

/**
 * Generate MCQs for a task using AI.
 * @summary Generate Mcqs
 */
export const generateMcqQuestions = (
  moduleId: string,
  version: string,
  taskId: string,
  mCQGenerationRequest: MCQGenerationRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MCQConfigOutput>> => {
  return axios.post(
    `/modules/${moduleId}/versions/${version}/tasks/${taskId}/mcq/generate`,
    mCQGenerationRequest,
    options,
  );
};

export const getGenerateMcqQuestionsMutationOptions = <
  TData = Awaited<ReturnType<typeof generateMcqQuestions>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: MCQGenerationRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['generateMcqQuestions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateMcqQuestions>>,
    { moduleId: string; version: string; taskId: string; data: MCQGenerationRequest }
  > = (props) => {
    const { moduleId, version, taskId, data } = props ?? {};

    return generateMcqQuestions(moduleId, version, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: MCQGenerationRequest },
    TContext
  >;
};

export type GenerateMcqQuestionsMutationResult = NonNullable<Awaited<ReturnType<typeof generateMcqQuestions>>>;
export type GenerateMcqQuestionsMutationBody = MCQGenerationRequest;
export type GenerateMcqQuestionsMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Generate Mcqs
 */
export const useGenerateMcqQuestions = <
  TData = Awaited<ReturnType<typeof generateMcqQuestions>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: MCQGenerationRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; data: MCQGenerationRequest },
  TContext
> => {
  const mutationOptions = getGenerateMcqQuestionsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Update MCQ configuration (lecturer edits).
 * @summary Update Mcq Config
 */
export const updateMcqConfig = (
  moduleId: string,
  version: string,
  taskId: string,
  mCQConfigInput: MCQConfigInput,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MCQConfigOutput>> => {
  return axios.patch(`/modules/${moduleId}/versions/${version}/tasks/${taskId}/mcq`, mCQConfigInput, options);
};

export const getUpdateMcqConfigMutationOptions = <
  TData = Awaited<ReturnType<typeof updateMcqConfig>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: MCQConfigInput },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateMcqConfig'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMcqConfig>>,
    { moduleId: string; version: string; taskId: string; data: MCQConfigInput }
  > = (props) => {
    const { moduleId, version, taskId, data } = props ?? {};

    return updateMcqConfig(moduleId, version, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: MCQConfigInput },
    TContext
  >;
};

export type UpdateMcqConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateMcqConfig>>>;
export type UpdateMcqConfigMutationBody = MCQConfigInput;
export type UpdateMcqConfigMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Update Mcq Config
 */
export const useUpdateMcqConfig = <
  TData = Awaited<ReturnType<typeof updateMcqConfig>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: MCQConfigInput },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; data: MCQConfigInput },
  TContext
> => {
  const mutationOptions = getUpdateMcqConfigMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Create a new MCQ question.
 * @summary Create Question
 */
export const createMcqQuestion = (
  moduleId: string,
  version: string,
  taskId: string,
  mCQQuestionCreate: MCQQuestionCreate,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MCQQuestion>> => {
  return axios.post(
    `/modules/${moduleId}/versions/${version}/tasks/${taskId}/mcq/questions`,
    mCQQuestionCreate,
    options,
  );
};

export const getCreateMcqQuestionMutationOptions = <
  TData = Awaited<ReturnType<typeof createMcqQuestion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: MCQQuestionCreate },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['createMcqQuestion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMcqQuestion>>,
    { moduleId: string; version: string; taskId: string; data: MCQQuestionCreate }
  > = (props) => {
    const { moduleId, version, taskId, data } = props ?? {};

    return createMcqQuestion(moduleId, version, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: MCQQuestionCreate },
    TContext
  >;
};

export type CreateMcqQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof createMcqQuestion>>>;
export type CreateMcqQuestionMutationBody = MCQQuestionCreate;
export type CreateMcqQuestionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Create Question
 */
export const useCreateMcqQuestion = <
  TData = Awaited<ReturnType<typeof createMcqQuestion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: MCQQuestionCreate },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; data: MCQQuestionCreate },
  TContext
> => {
  const mutationOptions = getCreateMcqQuestionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Update an existing MCQ question.
 * @summary Update Question
 */
export const updateMcqQuestion = (
  moduleId: string,
  version: string,
  taskId: string,
  questionId: string,
  mCQQuestionUpdate: MCQQuestionUpdate,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MCQQuestion>> => {
  return axios.put(
    `/modules/${moduleId}/versions/${version}/tasks/${taskId}/mcq/questions/${questionId}`,
    mCQQuestionUpdate,
    options,
  );
};

export const getUpdateMcqQuestionMutationOptions = <
  TData = Awaited<ReturnType<typeof updateMcqQuestion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string; data: MCQQuestionUpdate },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateMcqQuestion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMcqQuestion>>,
    { moduleId: string; version: string; taskId: string; questionId: string; data: MCQQuestionUpdate }
  > = (props) => {
    const { moduleId, version, taskId, questionId, data } = props ?? {};

    return updateMcqQuestion(moduleId, version, taskId, questionId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string; data: MCQQuestionUpdate },
    TContext
  >;
};

export type UpdateMcqQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof updateMcqQuestion>>>;
export type UpdateMcqQuestionMutationBody = MCQQuestionUpdate;
export type UpdateMcqQuestionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Update Question
 */
export const useUpdateMcqQuestion = <
  TData = Awaited<ReturnType<typeof updateMcqQuestion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string; data: MCQQuestionUpdate },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; questionId: string; data: MCQQuestionUpdate },
  TContext
> => {
  const mutationOptions = getUpdateMcqQuestionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete an MCQ question.
 * @summary Delete Question
 */
export const deleteMcqQuestion = (
  moduleId: string,
  version: string,
  taskId: string,
  questionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.delete(`/modules/${moduleId}/versions/${version}/tasks/${taskId}/mcq/questions/${questionId}`, options);
};

export const getDeleteMcqQuestionMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteMcqQuestion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteMcqQuestion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMcqQuestion>>,
    { moduleId: string; version: string; taskId: string; questionId: string }
  > = (props) => {
    const { moduleId, version, taskId, questionId } = props ?? {};

    return deleteMcqQuestion(moduleId, version, taskId, questionId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string },
    TContext
  >;
};

export type DeleteMcqQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMcqQuestion>>>;

export type DeleteMcqQuestionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Delete Question
 */
export const useDeleteMcqQuestion = <
  TData = Awaited<ReturnType<typeof deleteMcqQuestion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; questionId: string },
  TContext
> => {
  const mutationOptions = getDeleteMcqQuestionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Upload an image for an MCQ question.
 * @summary Upload Question Image
 */
export const uploadMcqQuestionImage = (
  moduleId: string,
  version: string,
  taskId: string,
  questionId: string,
  bodyUploadMcqQuestionImage: BodyUploadMcqQuestionImage,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  const formData = new FormData();
  formData.append('file', bodyUploadMcqQuestionImage.file);
  if (bodyUploadMcqQuestionImage.alt_text !== undefined) {
    formData.append('alt_text', bodyUploadMcqQuestionImage.alt_text);
  }

  return axios.post(
    `/modules/${moduleId}/versions/${version}/tasks/${taskId}/mcq/questions/${questionId}/image`,
    formData,
    options,
  );
};

export const getUploadMcqQuestionImageMutationOptions = <
  TData = Awaited<ReturnType<typeof uploadMcqQuestionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string; data: BodyUploadMcqQuestionImage },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['uploadMcqQuestionImage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadMcqQuestionImage>>,
    { moduleId: string; version: string; taskId: string; questionId: string; data: BodyUploadMcqQuestionImage }
  > = (props) => {
    const { moduleId, version, taskId, questionId, data } = props ?? {};

    return uploadMcqQuestionImage(moduleId, version, taskId, questionId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string; data: BodyUploadMcqQuestionImage },
    TContext
  >;
};

export type UploadMcqQuestionImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadMcqQuestionImage>>>;
export type UploadMcqQuestionImageMutationBody = BodyUploadMcqQuestionImage;
export type UploadMcqQuestionImageMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Upload Question Image
 */
export const useUploadMcqQuestionImage = <
  TData = Awaited<ReturnType<typeof uploadMcqQuestionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string; data: BodyUploadMcqQuestionImage },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; questionId: string; data: BodyUploadMcqQuestionImage },
  TContext
> => {
  const mutationOptions = getUploadMcqQuestionImageMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete an MCQ question's image.
 * @summary Delete Question Image
 */
export const deleteMcqQuestionImage = (
  moduleId: string,
  version: string,
  taskId: string,
  questionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.delete(
    `/modules/${moduleId}/versions/${version}/tasks/${taskId}/mcq/questions/${questionId}/image`,
    options,
  );
};

export const getDeleteMcqQuestionImageMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteMcqQuestionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteMcqQuestionImage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMcqQuestionImage>>,
    { moduleId: string; version: string; taskId: string; questionId: string }
  > = (props) => {
    const { moduleId, version, taskId, questionId } = props ?? {};

    return deleteMcqQuestionImage(moduleId, version, taskId, questionId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string },
    TContext
  >;
};

export type DeleteMcqQuestionImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMcqQuestionImage>>>;

export type DeleteMcqQuestionImageMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Delete Question Image
 */
export const useDeleteMcqQuestionImage = <
  TData = Awaited<ReturnType<typeof deleteMcqQuestionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; questionId: string },
  TContext
> => {
  const mutationOptions = getDeleteMcqQuestionImageMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Upload an image for an MCQ option.
 * @summary Upload Option Image
 */
export const uploadMcqOptionImage = (
  moduleId: string,
  version: string,
  taskId: string,
  questionId: string,
  optionId: string,
  bodyUploadMcqOptionImage: BodyUploadMcqOptionImage,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  const formData = new FormData();
  formData.append('file', bodyUploadMcqOptionImage.file);
  if (bodyUploadMcqOptionImage.alt_text !== undefined) {
    formData.append('alt_text', bodyUploadMcqOptionImage.alt_text);
  }

  return axios.post(
    `/modules/${moduleId}/versions/${version}/tasks/${taskId}/mcq/questions/${questionId}/options/${optionId}/image`,
    formData,
    options,
  );
};

export const getUploadMcqOptionImageMutationOptions = <
  TData = Awaited<ReturnType<typeof uploadMcqOptionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      moduleId: string;
      version: string;
      taskId: string;
      questionId: string;
      optionId: string;
      data: BodyUploadMcqOptionImage;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['uploadMcqOptionImage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadMcqOptionImage>>,
    {
      moduleId: string;
      version: string;
      taskId: string;
      questionId: string;
      optionId: string;
      data: BodyUploadMcqOptionImage;
    }
  > = (props) => {
    const { moduleId, version, taskId, questionId, optionId, data } = props ?? {};

    return uploadMcqOptionImage(moduleId, version, taskId, questionId, optionId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      moduleId: string;
      version: string;
      taskId: string;
      questionId: string;
      optionId: string;
      data: BodyUploadMcqOptionImage;
    },
    TContext
  >;
};

export type UploadMcqOptionImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadMcqOptionImage>>>;
export type UploadMcqOptionImageMutationBody = BodyUploadMcqOptionImage;
export type UploadMcqOptionImageMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Upload Option Image
 */
export const useUploadMcqOptionImage = <
  TData = Awaited<ReturnType<typeof uploadMcqOptionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      moduleId: string;
      version: string;
      taskId: string;
      questionId: string;
      optionId: string;
      data: BodyUploadMcqOptionImage;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    moduleId: string;
    version: string;
    taskId: string;
    questionId: string;
    optionId: string;
    data: BodyUploadMcqOptionImage;
  },
  TContext
> => {
  const mutationOptions = getUploadMcqOptionImageMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete an MCQ option's image.
 * @summary Delete Option Image
 */
export const deleteMcqOptionImage = (
  moduleId: string,
  version: string,
  taskId: string,
  questionId: string,
  optionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.delete(
    `/modules/${moduleId}/versions/${version}/tasks/${taskId}/mcq/questions/${questionId}/options/${optionId}/image`,
    options,
  );
};

export const getDeleteMcqOptionImageMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteMcqOptionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string; optionId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteMcqOptionImage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMcqOptionImage>>,
    { moduleId: string; version: string; taskId: string; questionId: string; optionId: string }
  > = (props) => {
    const { moduleId, version, taskId, questionId, optionId } = props ?? {};

    return deleteMcqOptionImage(moduleId, version, taskId, questionId, optionId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string; optionId: string },
    TContext
  >;
};

export type DeleteMcqOptionImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMcqOptionImage>>>;

export type DeleteMcqOptionImageMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Delete Option Image
 */
export const useDeleteMcqOptionImage = <
  TData = Awaited<ReturnType<typeof deleteMcqOptionImage>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; questionId: string; optionId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; questionId: string; optionId: string },
  TContext
> => {
  const mutationOptions = getDeleteMcqOptionImageMutationOptions(options);

  return useMutation(mutationOptions);
};
